//@ts-check
import React from 'react';
import DataGrid from './DataGrid';
import DataGridModeSwitcher from './ModeSwitcher';
import LocalTheme from '../../theme/LocalTheme';
/**@param {import('./types').DataGridExportProps} props */

function DataGridExport(props) {
  var gridTheme = React.useMemo(function () {
    return props.styles ? {
      common: {
        Data: {
          Grid: {
            style: {
              selectionColor: props.styles.selectionColor
            }
          }
        }
      }
    } : undefined;
  }, [props.styles && props.styles.selectionColor]);
  if (!props.id) return React.createElement("div", null, "DataGrid id prop is required!");
  return React.createElement(LocalTheme, {
    theme: gridTheme
  }, React.createElement(DataGrid, props));
}

DataGridExport.ModeSwitcher = DataGridModeSwitcher;
export default DataGridExport;